export default "__VITE_ASSET__a6a73b77__"